import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { AppendToBodyModule } from 'NewAngular/features/directives/append-to-body/append-to-body.module';
import { BaseAutocompleteModule } from '../base-autocomplete/base-autocomplete.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class AutocompleteInPlaceModule {
}
AutocompleteInPlaceModule.ɵfac = function AutocompleteInPlaceModule_Factory(t) { return new (t || AutocompleteInPlaceModule)(); };
AutocompleteInPlaceModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AutocompleteInPlaceModule });
AutocompleteInPlaceModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AppendToBodyModule,
        BaseAutocompleteModule,
        CommonModule,
        ConfirmModalModule,
        DisabledModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        MetricSelectorModalModule,
        TooltipModule] });
